// @ts-nocheck
/* eslint-disable */
export const appIndeterminate16Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="3" y1="8" x2="13" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'indeterminate-16' as const
};